import { createContext, useContext, useEffect, useState } from "react";
import { api, tokenStore, userStore } from "@/lib/api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => userStore.get());
  const [loading, setLoading] = useState(false);

  // Re-hydrate user from server if token exists
  useEffect(() => {
    const tk = tokenStore.get();
    if (tk && !user) {
      setLoading(true);
      api
        .get("/auth/me")
        .then((r) => {
          setUser(r.data);
          userStore.set(r.data);
        })
        .catch(() => {
          tokenStore.clear();
          setUser(null);
        })
        .finally(() => setLoading(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const login = async (username, password) => {
    const { data } = await api.post("/auth/login", { username, password });
    tokenStore.set(data.access_token);
    userStore.set(data.user);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    tokenStore.clear();
    setUser(null);
  };

  const refreshUser = async () => {
    const r = await api.get("/auth/me");
    setUser(r.data);
    userStore.set(r.data);
    return r.data;
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, logout, refreshUser }}>
      {children}
    </AuthCtx.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthCtx);
  if (!ctx) throw new Error("useAuth must be used inside AuthProvider");
  return ctx;
};
